import { Mustache } from '@/utils'

export default key => {
  key = key instanceof Array ? key : [key]

  let computed = key.reduce((res, cur) => {
    res[cur] = function () {
      try {
        return Mustache(this.value[cur], this.variables || {})
      } catch (err) {
        return this.value[cur]
      }
    }
    return res
  }, {})

  return {
    props: {
      value: Object,
      variables: Object,
    },
    computed,
  }
}
